const Auth0Config = {
  allowEditName: false,
  allowEditPhone: false,
  allowEditEmail: false,
  allowEditBirthday: false,
  allowEditAddress: false,
  allowChangePassword: false,
  allowMFA: false,
  allowCreateUser: false,
  allowDeleteUser: false,
  profileExplanation: 'To change your displayed name, email address, phone number or password, please contact staff.',
  showInitialPassword: false,
  editUserLoginText:
    'Editing login information can not be done within the Community Manager. Please contact relevant staff to make changes.',
};

export { Auth0Config };
